import {
  GridColDef,
  GridRowParams,
  GridValueFormatterParams,
} from '@mui/x-data-grid-pro'
import {
  tsPyAnimal,
  tsPyEnrolledAnimal,
} from '../../../Typescript/StuartPy/PyAnimal'
import { Chip } from '@mui/material'

type fieldeColDef = GridColDef & {
  field: keyof tsPyAnimal | keyof tsPyEnrolledAnimal | 'PhaseName'
  getActions?: (a: GridRowParams) => any
}

export const animalColsDF: fieldeColDef[] = [
  {
    field: 'ShortLineName',
    headerName: 'Line',
    flex: 2,
  },
  {
    type: 'number',
    field: 'AnimalID',
    headerName: 'AnimalID',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'AlternateID',
    headerName: 'AlternateID',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    type: 'number',
    field: 'ContainerID',
    headerName: 'ContainerID',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    valueFormatter: (params: GridValueFormatterParams<number>) => {
      if (!params?.value) {
        return ''
      }
      return `${params?.value}`
    },
  },
  {
    field: 'PhaseID',
    headerName: 'PhaseID',
    flex: 1,
  },
  {
    field: 'PhaseName',
    headerName: 'Phase',
    flex: 1,
    type: 'string',
    renderCell: ({ value }) => {
      if (value) {
        return value
      } else {
        return (
          <Chip
            label={'Not Enrolled'}
            color={'warning'}
            variant={'outlined'}
          />
        )
      }
    },
  },
  {
    field: 'ProtocolID',
    headerName: 'ProtocolID',
    flex: 1,
  },
  {
    field: 'EthicsNumber',
    headerName: 'Ethics Number',
    flex: 1,
  },
]
